import {CalendarSpec} from 'moment';

// eslint-disable-next-line no-shadow
export enum OnFleetEvents {
  driverUpdate = 'driverUpdate',
  tasksUpdate = 'tasksUpdate',
  logout = 'logout',
  provisioning = 'provisioning',
  addImagesUploading = 'addImagesUploading',
  removeImageUploading = 'removeImageUploading',
}

export interface OnfleetBarcodeData {
  data: string;
  blockCompletion: boolean;
}

export interface Task {
  completeAfter: string;
  completeBefore: string;
  destinationAddress: DestinationAddress;
  id: string;
  metadata: Metadata;
  minimumAge: number;
  notesRequired: boolean;
  photoRequired: boolean;
  quantity: string;
  recipientName: string;
  recipientPhone: string;
  shortId: string;
  signatureRequired: boolean;
  state: string;
  taskType: string;
  barcodes: OnfleetBarcodeData[];
  bagsUsed: number;
}
export interface DestinationAddress {
  address: string;
  city: string;
  country: string;
  googlePlaceId: string;
  locationLatitude: number;
  locationLongitude: number;
  postalCode: string;
  state: string;
  timeCreated?: null;
  notes?: string;
}
export interface Metadata {
  [key: string]: any;
}

export const momentFormatter: CalendarSpec = {
  lastDay: '[Yesterday]',
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'dddd',
  sameElse: 'L',
};

export interface CompleteTaskFailureParams {
  success: boolean;
  failureReason: string;
  notes: string;
}

export interface OnfleetBarcode {
  symbology: string;
  data: string;
  wasRequested: boolean;
}

export interface IdCaptureDetails {
  dateOfBirth?: number | null;
  documentId?: string | null;
  documentType?: string | null;
  issuingCountry?: string | null;
  dateIssued?: number | null;
  expirationDate?: number | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  scan: boolean;
}

export interface CompleteTaskSuccessParams {
  success: boolean;
  barcodes?: OnfleetBarcode[];
  notes?: string;
  photos?: string[];
  ageDetails?: IdCaptureDetails;
  signatureDetails?: {
    name: string;
  };
}

// eslint-disable-next-line no-shadow
export enum LoginStatus {
  SUCCESS = 'SUCCESS',
  SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS',
  WAIT_PROVISIONING = 'WAIT_PROVISIONING',
  PROVISIONING_COMPLETED_LOG_IN = 'PROVISIONING_COMPLETED_LOG_IN',
  WAIT_ADMIN_VERIFICATION = 'WAIT_ADMIN_VERIFICATION', // Deprecated
  WAIT_SMS_VERIFICATION = 'WAIT_SMS_VERIFICATION',
  RECEIVED_SMS_VERIFICATION = 'RECEIVED_SMS_VERIFICATION',
  SET_NEW_PASSWORD = 'SET_NEW_PASSWORD',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NO_ORGANIZATION = 'NO_ORGANIZATION',
  INVALID_PHONE = 'INVALID_PHONE',
  INCORRECT_DEVICE_TIME = 'INCORRECT_DEVICE_TIME',
  INCORRECT_SMS_CODE = 'INCORRECT_SMS_CODE',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NO_ACCOUNTS = 'NO_ACCOUNTS',
  ACCOUNT_ACCESS_DISABLED = 'ACCOUNT_ACCESS_DISABLED',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  NETWORK_ERROR = 'NETWORK_ERROR',
}

// eslint-disable-next-line no-shadow
export enum SendOnTheWayStatus {
  SUCCESS = 'SUCCESS',
  NETWORK_ERROR = 'NETWORK_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  UNAVAILABLE_ERROR = 'UNAVAILABLE_ERROR',
  ACTIVE_TASK_ERROR = 'ACTIVE_TASK_ERROR',
  ALREADY_STARTED_ERROR = 'ALREADY_STARTED_ERROR',
  PREREQUISITE_NOT_COMPLETED_ERROR = 'PREREQUISITE_NOT_COMPLETED_ERROR',
}

// eslint-disable-next-line no-shadow
export enum CompleteTaskResponse {
  SUCCESS = 'SUCCESS',
  NETWORK_ERROR = 'NETWORK_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  ALREADY_COMPLETED_ERROR = 'ALREADY_COMPLETED_ERROR',
  REQUIRED_PROPERTY_NOT_PROVIDED = 'REQUIRED_PROPERTY_NOT_PROVIDED',
}

// eslint-disable-next-line no-shadow
export enum LogInStates {
  loggedIn = 'LOGGED_IN',
  provisioning = 'PROVISIONING',
  authenticating = 'AUTHENTICATING',
  logInFailed = 'LOG_IN_FAILED',
}

export interface EnvConfig {
  prod: string;
  dev: string;
}

export interface OnfleetConfig {
  b2bOrganization: EnvConfig;
  bunchaOrganization: EnvConfig;
}
